exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".matrizForm {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin: 0 auto;\n  gap: 4rem;\n  max-width: 900px; }\n  .matrizForm mat-form-field {\n    width: 100%; }\n  .matrizForm .field_wrapper {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: start;\n        align-items: flex-start;\n    gap: 2rem; }\n    .matrizForm .field_wrapper .help_btn {\n      outline: none;\n      color: #17aa5d; }\n  .matrizForm .file_input {\n    margin-bottom: 1rem; }\n\n.btn_wrap {\n  max-width: 900px;\n  margin: 0 auto; }\n\n.search_input {\n  padding: 0.5rem;\n  background-color: #cccccc;\n  z-index: 1000; }\n\n.show_errors {\n  padding: 1rem;\n  margin: 3rem auto 1rem;\n  border-radius: 10px;\n  max-width: 900px; }\n  .show_errors.has_error {\n    background-color: #da9999; }\n  .show_errors.no_error {\n    background-color: #99daa3; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/import-matriz/import-matriz.component.scss
// module id = ../../../../../src/app/components/import-matriz/import-matriz.component.scss
// module chunks = main